import * as React from 'react';

export interface EmailTranscriptButtonProps {
  handleClick: () => void;
}
export const EmailTranscriptButton = ({
  handleClick,
}: EmailTranscriptButtonProps) =>
  (
    <button
      type="button"
      className="btn-green"
      onClick={handleClick}
    >
      Email Transcript
    </button>
  );
